"use client"

import * as React from "react"
import { DashboardSectionTitle } from "@/components/dashboard-section-heading"
import { AllTermsTable } from "./all-terms-table"
import type { EvaluationTerm } from "@/lib/mock/evaluation-dashboard"

interface AllTermsSectionProps {
  terms: EvaluationTerm[]
}

export function AllTermsSection({ terms }: AllTermsSectionProps) {
  if (terms.length === 0) return null

  return (
    <section
      id="eval-all-terms"
      aria-labelledby="eval-all-terms-heading"
      className="flex scroll-mt-6 flex-col gap-4 border-t border-border/60 pt-10"
    >
      <DashboardSectionTitle as="h2" id="eval-all-terms-heading">
        All terms ({terms.length})
      </DashboardSectionTitle>
      <AllTermsTable terms={terms} />
    </section>
  )
}
